<template>
    <div class="trophy-list card card-shadow overflow-hidden">
        <div class="trophy-list-nav card-inner background-lightblue flex">
            <div class="nav-item hover no-select">
                <p class="extra-light-text" @click="view = 'all'" :class="{'bold-text secondary-c': view === 'all'}">{{ translations['trophy.trophyroom_allbadges'] }}</p>
            </div>
            <div class="nav-item hover no-select">
                <p class="extra-light-text" @click="view = 'earned'" :class="{'bold-text secondary-c': view === 'earned'}">{{ translations[ 'trophy.trophyroom_earnedbadges' ]}}</p>
            </div>
            <div class="nav-item hover no-select">
                <p class="extra-light-text" @click="view = 'unachieved'" :class="{'bold-text secondary-c': view === 'unachieved'}">{{ translations[ 'trophy.trophyroom_unachievedbadges' ]}}</p>
            </div>
            <div class="nav-item hover no-select">
                <p class="extra-light-text" @click="view = 'granted'" :class="{'bold-text secondary-c': view === 'granted'}">{{ translations[ 'trophy.trophyroom_grantedbadges' ]}}</p>
            </div>
        </div>
        <div class="card-inner">
            <template v-if="filteredTrophies.length > 0">
                <div class="flex flex-col-3 flex-col-2-lg flex-col-2-xm flex-col-2-m flex-col-2-s flex-col-1-xs">
                    <div class="flex-child" v-for="trophy in filteredTrophies" :key="trophy.id">
                        <trophy style="width: 90%;"
                                :trophy="trophy"
                                :showTitle="true"
                                :showDesc="true"
                                :view="view"
                                orientation="horizontal">
                        </trophy>
                    </div>
                    <div class="flex-child empty"></div>
                    <div class="flex-child empty"></div>
                </div>
            </template>
            <template v-else-if="trophies.length !== 0">
                <p class="extra-light-text">No trophies to be displayed here!</p>
            </template>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import orderBy from 'lodash.orderby';
    import filter from 'lodash.filter';
    import reject from 'lodash.reject';

    import Global from '../../mixins/Global.js'

    export default {
        name: 'TrophyList',
        mixins:[Global],

        data() {
            return {
                view: 'all',
            }
        },

        computed: {
            ...mapState([
                'trophies'
            ]),

            filteredTrophies() {
                let trophies = this.trophies;

                if(this.view === 'all') {
                    trophies = orderBy(trophies, 'progress', 'desc');
                } else if(this.view === 'earned') {
                    trophies = filter(trophies, function(trophy) {
                        return trophy.progress >= 100 || trophy.category === 'custom' || trophy.rank > 1
                    });
                } else if(this.view === 'unachieved') {
                    trophies = reject(trophies, function (trophy) {
                        return trophy.progress >= 100
                    });
                    trophies = reject(trophies, function (trophy) {
                        return trophy.category === 'custom'
                    });
                } else if(this.view === 'granted') {
                    trophies = filter(trophies, function(trophy) {
                        return trophy.category === 'custom'
                    });
                }

                return trophies;
            },
        },
    }
</script>

<style lang="scss">
    .trophy-list {
        padding-bottom: 22px;

        .trophy-list-nav {
            padding-bottom: 0;

            .nav-item {
                margin-right: 30px;

                p {
                    padding-bottom: 14px;
                    padding-left: 7px;
                    padding-right: 7px;

                    &.secondary-c {
                        border-bottom: 3px solid;
                    }
                }

                @media(max-width: 576px) {
                    margin-right: 15px;

                    p {
                        font-size: 12px;
                    }
                }
            }

            @media(max-width: 576px) {
                padding-left: 12px;
            }
        }

        .disable-trophy {
            display: none;
        }
        .sub-cat{
            //order: 1;
        }
    }
</style>